import React, { Component } from 'react';
import YouTube from 'react-youtube';
import { translate } from '../../../services';
import { connect } from 'react-redux';
import { siteSettingsState } from '../../../store';

export class WelcomeComponent extends Component {
  constructor() {
    super();

    this.state = {
      width: this.getWidth()
    };
  }

  componentDidMount() {
    window.addEventListener( 'resize', this.onResize );
  }

  componentWillUnmount() {
    window.removeEventListener( 'resize', this.onResize );
  }

  getWidth() {
    const defaultWidth = Math.min( window.innerWidth - 40, 860 );

    if( window.innerWidth <= 1366 ) {
      return defaultWidth * 0.8;
    }

    if( window.innerWidth < 1920 ) {
      return defaultWidth * 0.9;
    }

    return defaultWidth;
  }

  onResize = () => {
    this.timeout && clearTimeout( this.timeout );
    this.timeout = setTimeout( () => {
      const width = this.getWidth();
      width !== this.state.width && this.setState( { width } ); 
    }, 100 );
  }

  render() {
    const { width } = this.state;
    const { siteSettings } = this.props;

    return <div className="welcome">
      <div>
        <h1>{ translate( 'Welcome to e-Configure' ) }</h1>
        <h3>{ translate( 'First time here?' ) }</h3>
        <span>{ translate( 'The easiest way to find, select, configure and order ABB products, quickly and simply.' ) }</span>
        {siteSettings.properties.showWelcomeVideo &&  <>
          <span>{ translate( 'Have a look at the video below!' ) }</span>
          <YouTube className="youtube-video" videoId="MMZEG-5xmnY" opts={ { height: width * 9 / 16, width, playerVars: { autoPlay: 0 } } } />
        </>}
      </div>
    </div>;
  }
}

export const Welcome = connect(siteSettingsState)( WelcomeComponent );